import {
  Input,
  List,
  Button,
  Form as AntForm,
  Collapse,
  Switch,
  DatePicker,
  Space,
} from "antd";
import { Formik, Form, FieldArray } from "formik";
import { useState, useContext, useEffect } from "react";
import KnowledgeConfigContext from "./KnowledgeConfigContext";
import knowledgeIndex from "./knowledgeIndex";

const riyadhLinks = [
  "https://www.kkia.sa/en/GeneralServices/ContactUs/Pages/default.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/Pages/Clicknadcollect.aspx",
  "https://www.kkia.sa/en/before-you-fly/Baggage/Pages/Lost_and_Found.aspx",
  "https://www.kkia.sa/en/GeneralServices/Explore-Riyadh/Pages/the-antiquities-museum.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Parking/Pages/default.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/",
  "https://www.kkia.sa/en/Services/AirportServices/lounges/",
  "https://www.kkia.sa/en/Services/AirportServices/Dining/",
  "https://www.kkia.sa/en/GeneralServices/Pages/FreeWiFi.aspx",
  "https://www.kkia.sa/en/GeneralGuidance/Pages/PassengerAwareness.aspx",
  "https://www.kkia.sa/en/GeneralGuidance/Pages/COVID-19Pandemic.aspx",
  "https://www.kkia.sa/en/GeneralServices/FAQs/",
  "https://www.kkia.sa/en/Services/MotherServices/Pages/default.aspx",
  "https://www.kkia.sa/en/GeneralServices/FAQs/Pages/default.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/Pages/default.aspx?terminal=terminal%202",
  "https://www.kkia.sa/en/Services/AirportServices/lounges/Pages/default.aspx?terminal=Terminal%205",
  "https://www.kkia.sa/en/before-you-fly/baggage/Pages/lost_and_found.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/lounges/Pages/default.aspx?terminal=Terminal%204",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/Pages/default.aspx?terminal=terminal%204",
  "https://www.kkia.sa/en/GeneralServices/User_Journey/Pages/transit.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/Pages/default.aspx?terminal=terminal%205",
  "https://www.kkia.sa/en/GeneralServices/Pages/Complaints.aspx",
  "https://www.kkia.sa/en/Services/Pages/SensoryRoom.aspx",
  "https://www.kkia.sa/en/before-you-fly/Baggage/Pages/Baggage_regulations.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/Pages/default.aspx",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Car_Rental/Pages/default.aspx?terminal=terminal%203",
  "https://www.kkia.sa/en/Services/AirportServices/lounges/Pages/default.aspx?terminal=Terminal%203",
  "https://www.kkia.sa/en/Services/AirportServices/lounges/Pages/default.aspx",
  "https://www.kkia.sa/en/GeneralServices/ContactUs/",
  "https://www.kkia.sa/en/Services/AirportServices/To_from_the_airport/Parking/",
];

const QuestionnaireForm = ({ initialValues, macroSave }) => {
  initialValues = initialValues || {
    questions: [
      {
        question: "Où puis-je dormir ?",
        answer: "Il y a pleins de super hotel ou vous pouvez dormir !",
        active: true,
      },
      // ... other questions
    ],
    expirationDate: null,
  };
  const [savedData, setSavedData] = useState(initialValues);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    macroSave(savedData);
  }, [savedData, macroSave]);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(false);
      }}
    >
      {({ values, setFieldValue }) => (
        <AntForm layout="vertical">
          <Space direction="vertical" className="w-full">
            <FieldArray
              name="questions"
              render={(arrayHelpers) => (
                <div>
                  {values.questions.map((item, index) => (
                    <AntForm.Item key={index} label={`Q${index + 1}`}>
                      <Space direction="vertical" className="w-full">
                        <Input
                          value={item.question}
                          onChange={(e) =>
                            setFieldValue(
                              `questions.${index}.question`,
                              e.target.value
                            )
                          }
                          placeholder="Question"
                        />
                        <Input.TextArea
                          value={item.answer}
                          onChange={(e) =>
                            setFieldValue(
                              `questions.${index}.answer`,
                              e.target.value
                            )
                          }
                          placeholder="Answer"
                        />
                        <DatePicker
                          showTime
                          onChange={(date, dateString) =>
                            setFieldValue(
                              `questions.${index}.expirationDate`,
                              dateString
                            )
                          }
                          placeholder="Expiration Date"
                        />
                        <Switch
                          checked={item.active}
                          onChange={(checked) =>
                            setFieldValue(`questions.${index}.active`, checked)
                          }
                        />
                        <Button
                          danger
                          onClick={() => arrayHelpers.remove(index)}
                        >
                          Delete
                        </Button>
                      </Space>
                    </AntForm.Item>
                  ))}
                  <Button
                    type="dashed"
                    onClick={() =>
                      arrayHelpers.push({
                        question: "",
                        answer: "",
                        active: true,
                        expirationDate: null,
                      })
                    }
                  >
                    Add question
                  </Button>
                </div>
              )}
            />
            <AntForm.Item>
              <Button
                type="primary"
                disabled={
                  JSON.stringify(values) === JSON.stringify(savedData) ||
                  isSubmitting
                }
                onClick={() => {
                  setSavedData(values);
                }}
              >
                Save Changes
              </Button>
            </AntForm.Item>
          </Space>
        </AntForm>
      )}
    </Formik>
  );
};

const WebPageKnowledge = ({ initialValues, macroSave }) => {
  initialValues = initialValues || {
    links: [{ url: "", lastUpdated: "Never" }],
  };
  const [savedData, setSavedData] = useState(initialValues);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    macroSave(savedData);
  }, [savedData, macroSave]);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        // Here you would handle form submission, e.g., send data to an API.
        setSubmitting(false);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form>
          <FieldArray
            name="links"
            render={(arrayHelpers) => (
              <List
                itemLayout="horizontal"
                dataSource={values.links}
                renderItem={(item, index) => (
                  <List.Item
                    actions={[
                      <Button
                        key="update"
                        type="primary"
                        onClick={() => {
                          arrayHelpers.replace(index, {
                            ...item,
                            lastUpdated: new Date().toLocaleString(),
                          });
                        }}
                      >
                        Update
                      </Button>,
                      <Button
                        key="delete"
                        danger
                        onClick={() => arrayHelpers.remove(index)}
                      >
                        Delete
                      </Button>,
                    ]}
                  >
                    <List.Item.Meta
                      title={
                        <Input
                          value={item.url}
                          placeholder="https://siteinternet.com/p1"
                          onChange={(e) => {
                            arrayHelpers.replace(index, {
                              ...item,
                              url: e.target.value,
                            });
                          }}
                        />
                      }
                      description={`Last updated: ${item.lastUpdated}`}
                    />
                  </List.Item>
                )}
              />
            )}
          />
          <Space direction="vertical">
            <AntForm.Item>
              <Button
                type="dashed"
                onClick={() => {
                  const newLink = {
                    url: "",
                    lastUpdated: "Never",
                  };
                  setFieldValue("links", [...values.links, newLink]);
                }}
              >
                Add Link
              </Button>
            </AntForm.Item>
            <AntForm.Item>
              <Button
                type="primary"
                disabled={
                  JSON.stringify(values) === JSON.stringify(savedData) ||
                  isSubmitting
                }
                onClick={() => {
                  setSavedData(values);
                }}
              >
                Save Changes
              </Button>
            </AntForm.Item>
          </Space>
        </Form>
      )}
    </Formik>
  );
};

const KnowledgeEditor = ({ brand }) => {
  const [savedData, setSavedData] = useState({
    webPage: null,
    questionAnswer: null,
  });
  const { setKnowledgeConfig } = useContext(KnowledgeConfigContext);

  useEffect(() => {
    if (brand === "ADL") {
      setSavedData({
        ...savedData,
        webPage: {
          links: riyadhLinks.map((link) => ({
            url: link,
            lastUpdated: "yesterday at 11h32",
          })),
        },
      });
    }
  }, [brand]);

  const turnToKnowledgeInstructions = ({ webPage, questionAnswer }) => {
    let instructions = "";
    if (questionAnswer) {
      let q_and_a = questionAnswer.questions.map(
        (question) =>
          "Q: " + question.question + "\nA: " + question.answer + "\n---\n"
      );
      q_and_a = q_and_a.join("\n");
      instructions +=
        "Here is a FAQ to help you give answers:\n" + q_and_a + "\n\n";
    }
    console.log(webPage);
    if (webPage) {
      let links = webPage.links.map((link) => link.url);
      instructions += "Here are web pages that can help you:\n";
      for (let link of links) {
        instructions += knowledgeIndex[link] + "\n";
      }
    }
    return instructions;
  };

  useEffect(() => {
    const knowledgeInstructions = turnToKnowledgeInstructions(savedData);
    setKnowledgeConfig(knowledgeInstructions);
  }, [savedData]);

  return (
    <div>
      <Collapse
        items={[
          {
            label: "Web Page",
            key: "1",
            children: (
              <WebPageKnowledge
                initialValues={savedData.webPage}
                macroSave={(data) => {
                  if (
                    JSON.stringify(data) === JSON.stringify(savedData.webPage)
                  )
                    return;
                  setSavedData({
                    ...savedData,
                    webPage: data,
                  });
                }}
              />
            ),
          },
          {
            label: "Question/Answer",
            key: "2",
            children: (
              <QuestionnaireForm
                initialValues={savedData.questionAnswer}
                macroSave={(data) => {
                  if (
                    JSON.stringify(data) ===
                    JSON.stringify(savedData.questionAnswer)
                  )
                    return;
                  setSavedData({
                    ...savedData,
                    questionAnswer: data,
                  });
                }}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default KnowledgeEditor;
